export default class LoadingOverlay {
    constructor() {
        this.identifier = '[data-loading-overlay]';
        this.timeout = null;
        this.message = null;
        this.messageIdentifier = this.identifier + ' [data-message]';
    }

    taskStarted(timeout = 2000) {
        this.setActiveTasks(this.getActiveTasks() + 1);
        this.setTimeout(timeout);
    }

    taskFinished() {
        let numTasks = this.getActiveTasks();
        if (numTasks >= 1) {
            this.setActiveTasks(--numTasks);
        }
        this.clearMessage();
    }

    setTimeout(timeout = 2000) {
        if (this.timeout) {
            clearTimeout(this.timeout);
        }
        this.timeout = setTimeout(this.applyTimeout.bind(this), timeout);
    }

    applyTimeout() {
        if (this.timeout) {
            clearTimeout(this.timeout);
        }
        this.setActiveTasks(0);
        this.timeout = null;
    }

    getActiveTasks() {
        return parseInt(document.querySelector(this.identifier).dataset.activeTasks);
    }

    setActiveTasks(numTasks) {
        document.querySelector(this.identifier).dataset.activeTasks = numTasks;
    }

    clearMessage() {
        document.querySelector(this.messageIdentifier).innerHTML = null;
    }

    setMessage(message) {
        document.querySelector(this.messageIdentifier).innerHTML = message;
    }
}
